import React, {Children, cloneElement, useState} from "react";
import {ExpandMore} from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import {Accordion, AccordionDetails} from '@material-ui/core';
import {withTranslate} from 'react-admin';
import {Tooltip} from "@mui/material";


const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
})(MuiAccordionSummary);


export const CustomAccordion = withTranslate(({title, permanentlyExpanded, children, translate, label, className, summaryProps, detailsClassName, summaryTooltip, ...props}) => {

    const [expanded, setExpanded] = useState(false);

    const handleAccordionChange = (event, isExpanded) => {
        setExpanded(isExpanded);
    };

    const summary = <AccordionSummary expandIcon={<ExpandMore/>} {...summaryProps} >
        {title ? title : expanded ? translate('app.message.expand_hide') : translate('app.message.expand_show')}
    </AccordionSummary>;

    return <Accordion
        TransitionProps={{unmountOnExit: true}}
        onChange={handleAccordionChange}
        className={className}
        expanded={permanentlyExpanded}
        {...props}
    >
        {summaryTooltip ? <Tooltip title={summaryTooltip} disableInteractive slotProps={{popper: {sx: {zIndex: 1000}}}}>{summary}</Tooltip> : summary}
        <AccordionDetails className={detailsClassName}>
            {Children.map(children, ch => cloneElement(ch, props))}
        </AccordionDetails>
    </Accordion>
});
